/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * includes standard frequency type enum above, but also includes non-standard frequencies
 * too overloaded to include in the core enum. This is more used for presentational concerns than actually
 * driving any task creation/schedules which is driven more by rrule primitive frequencies
 */
export enum CollectionPlanFrequencyEnum {
    DAY = 'DAY',
    WEEK = 'WEEK',
    MONTH = 'MONTH',
    QUARTER = 'QUARTER',
    SEMI_ANNUAL = 'SEMI_ANNUAL',
    ANNUAL = 'ANNUAL',
    COMPANY_INITIATED = 'COMPANY_INITIATED',
    DOES_NOT_REPEAT = 'DOES_NOT_REPEAT',
}
